import gql from 'graphql-tag';

export default {
  applyPromoCode: gql`
    mutation applyPromocode($code: String!, $cartToken: String!) {
      applyPromocodeForCart(code: $code, cartToken: $cartToken) {
        success
        error
        warning
        info
      }
    }
  `,
  getInfo: gql`
    query getPromocodeInfo($code: String!) {
      getPromocodeInfo(code: $code) {
        success
        info
        warning
        error
        errorCode
        promocodeItem {
          id
          is_mobile_only
        }
      }
    }
  `
};
